import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GeneralGuideComponent } from './general-guide/general-guide.component';
import { sharedModule } from 'src/app/shared/shared.module';
import { GuideTreeSearchComponent } from './guide-tree-search/guide-tree-search.component';
import { coreModule } from 'src/app/core/core.module';

@NgModule({
  imports: [
    CommonModule,
    sharedModule,
    coreModule
  ],
  declarations: [
    GeneralGuideComponent,
    GuideTreeSearchComponent,
  ],
  entryComponents: [
    GuideTreeSearchComponent
  ]
})
export class GuidanceModule { }
